<template>
  <div class="file-item">
    <div class="flex flex-dir-column flex-justify-center">
      <i class="el-icon-document file-icon"></i>
      <div class="file-title">{{ file.url.slice(file.url.lastIndexOf('.') + 1) }}</div>
    </div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    file: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },
};
</script>

<style lang="scss" scoped>
$image-item-width: 148px;

.file-item {
  text-align: center;
  display: inline-block;
  vertical-align: top;
  width: $image-item-width;
  height: $image-item-width;
  position: relative;
  border: 1px solid #c0ccda;
  border-radius: 6px;
  margin: 0 8px 8px 0;
  overflow: hidden;
}
.file-icon {
  color: #c0ccda;
  font-size: 100px;
}
.file-title {
  color: #c0ccda;
  font-size: 20px;
}
.file-item:hover {
  .file-item-actions {
    opacity: 1;
  }
}
.file-item-actions {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: 0;
  transition: opacity 0.3s;

  > span {
    color: #fff;
    font-size: 20px;
    display: inline-block;
    cursor: pointer;
    opacity: 0.8;
    position: initial;
    margin: 0 3px;
    padding: 5px;
    transition: opacity 0.3s;

    &:hover {
      opacity: 1;
    }
  }
}
</style>

<style lang="scss">
</style>
